<template>
    <div class="card mb-3" style="min-height: 60vh;">
        <a-drawer v-if="account != null" :visible="showDrawerViewDetails" :width="680" placement="right" @close="onClose">
            <h6 class="heading-small text-muted">Account Basic Information</h6>
            <br>
            <div  class="col-xl-12 col-lg-12">
                <stats-card :title="account.company_name"
                            type="gradient-green"
                            :sub-title="account.account_name"
                            icon="ni ni-building"
                            class="mb-4 mb-xl-0">
                    <template slot="footer">
                        <span class="mr-2"> Status: {{account.status}} </span> <br>
                        <span class="mr-2"> Created: {{account.formatted_created_at}} </span>
                         <br>  <br>
                        <span class="account-type-container">
                            <div class="account-label-container">Account Type :</div>
                            <a-select v-model="selectedAccountType" style="width: 65%" @change="setAccountType(account.id)">
                                <a-select-option  v-for="(account_type, index) in accountTypes"
                                :key="index"
                                :value="account_type.id">
                                {{ account_type.name }}
                                </a-select-option>
                            </a-select>
                        </span>
                        <br>
                        <!-- <button type="button" class="btn btn-sm btn-info float-right mr-2" style="width: 25%" @click.prevent="setUpdate(account.id)">Update</button>  -->
                    </template>                    
                </stats-card>

                <br><br>

                <a-tabs v-model="activeKey" type="card">
                  <a-tab-pane tab="Company Details" key="1">
                    <div class="col-md-12">
                        <h6 class="heading-small text-muted">COMPANY NAME</h6>
                        {{account.company_name}} <br><br>

                        <h6 class="heading-small text-muted">TIN NUMBER</h6>
                        {{account.companyTin}} <br><br>
 
                        <h6 class="heading-small text-muted">ADDRESS</h6>
                        {{account.companyAddress}} <br><br>

                        <h6 class="heading-small text-muted">CONTACT NUMBER</h6>
                        {{account.telephone_no}} <br><br>
                    </div>
                  </a-tab-pane>
                  <a-tab-pane tab="Sites" key="2">
                    <table class="table table-sm">
                        <tr>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Billing Type</th>
                        </tr>
                        <tr v-for="site in account.sites" :key="site.id">
                            <td style="width: 40%">{{site.name}}</td>
                            <td style="width: 20%">{{site.status}}</td>
                            <td style="width: 40%">
                                <a-select v-model="site.billing_type_id"
                                    style="width: 100%"
                                    @change="setBillingType(account.id, site.billing_type_id, site.id)">
                                    <a-select-option  v-for="(billing_type, index) in billingTypes"
                                    :key="index"
                                    :value="billing_type.id">
                                    {{ billing_type.name }}
                                    </a-select-option>
                                </a-select>
                            </td>
                        </tr>
                    </table>
                  </a-tab-pane>
                  <a-tab-pane tab="Users" key="3">
                    <table class="table table-sm">
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Status</th>
                        </tr>
                        <tr v-for="user in account.users" :key="user.id">
                            <td>{{user.name}}</td>
                            <td>{{user.email}}</td>
                            <td>{{user.status}}</td>
                        </tr>
                    </table>
                  </a-tab-pane>
                </a-tabs>
            </div>
            
            <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                <button type="button" class="btn btn-sm btn-danger float-right" style="width: 25%">Delete</button> 
                <button v-if="account.status == 'A'" type="button" class="btn btn-sm btn-warning float-right mr-3" style="width: 25%" @click.prevent="updateAccountStatus(account.id, 'S')">Suspend</button> 
                <button v-if="account.status == 'S'" type="button" class="btn btn-sm btn-success float-right mr-3" style="width: 25%" @click.prevent="updateAccountStatus(account.id, 'A')">Activate</button> 
            </div>
    
        </a-drawer>
        <a-drawer :visible="showDrawer" :width="480" placement="right" @close="onClose">
            ADD ACCOUNT
            <form id="form-proper">
                <br>
                <h6 class="heading-small text-muted">Basic Information</h6>
                <base-input alternative="" label="Account Name" placeholder="Account Name" v-model="accountName" input-classes="form-control" required />
                <base-input alternative="" label="Account Type" input-classes="form-control" required>
                    <a-select v-model="accountType" 
                        placeholder="Select Account Type"
                        @change="getSelectedAccountType">
                        <a-select-option  v-for="list in accountTypes"
                        :key="list.id"
                        :value="list.id">{{ list.name }}
                        </a-select-option>
                    </a-select>
                </base-input>
                <base-input alternative="" label="Company Name" placeholder="Company Name" v-model="companyName" input-classes="form-control" required />
                <base-input alternative="" label="Business Type" input-classes="form-control" required>
                    <a-select  v-model="businessType"
                    placeholder="Select Business Type"
                    @change="getSelectedBusinessType">
                        <a-select-option
                        v-for="list in system_business_type_list"
                        :key="list.id"
                        :value="list.id"
                        >{{ list.name }}
                        </a-select-option>
                    </a-select>
                </base-input>
                <base-input alternative="" label="TIN Number" placeholder="TIN Number" v-model="companyTinNumber" input-classes="form-control" required />
                <base-input alternative="" label="Company Address" placeholder="Company Address"  v-model="companyAddress" input-classes="form-control" required />

                <h6 class="heading-small text-muted">Contact Information</h6>
                <base-input label="Owner Name" required>
                    <div class="form-group row">
                        <div class="col-sm-6" style="padding-right: 3px">
                            <input type="text" class="form-control" placeholder="First Name" v-model="firstName">
                        </div>
                        <div class="col-sm-6" style="padding-left: 3px">
                            <input type="text" class="form-control" placeholder="Last Name" v-model="lastName">
                        </div>
                    </div>
                </base-input>

                <base-input alternative="" label="Contact Number" placeholder="" input-classes="form-control" type="number" v-model="contactNumber" required />

                <h6 class="heading-small text-muted">Login Information</h6>
                <base-input alternative="" label="Username" placeholder="" input-classes="form-control" v-model="userName" required/>
                <base-input alternative="" label="Email Address" placeholder="" input-classes="form-control" v-model="emailAddress" required/>
                <base-input alternative="" label="Email Address Confirmation" placeholder="" input-classes="form-control" v-model="emailAddressConfirmation" required />
                <base-input alternative="" label="Password" placeholder="" input-classes="form-control" required type="password" v-model="password"/>
                <base-input alternative="" label="Password Confirmation" placeholder="" input-classes="form-control" required type="password" v-model="passwordConfirmation"/>


                <button type="button" class="btn btn-sm btn-secondary float-right" @click.prevent="onClose">Close</button> 
                <button type="button" class="btn btn-sm btn-primary float-right mr-3" @click.prevent="createAccount">Create</button> 
                <br>
                
            </form>
        </a-drawer>
        <div style="min-height: 60vh;">
          <div class="card-body">
            <div class="row">
                <div class="col-md-10"><h2>Account List</h2></div>
                <div class="col-md-2"><button class="btn btn-sm btn-default float-right" @click.prevent="addAccount">+ Add Account</button></div>
                <div class="table-responsive" >
                    <vuetable  ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields" 
                    :show-sort-icons="true" :per-page="10" :css="css.table" pagination-path="" data-path="data"
                    @vuetable:load-error="onLoadError" 
                    @vuetable:pagination-data="onPaginationData">
            
                    <template slot="actions" slot-scope="props">
                        <!-- {{props}} -->
                    <!-- <template slot="actions"> -->
                      <center>
                        <button class="btn btn-success btn-sm" @click.prevent="showAccountDetails(props.rowData.id)">Update Details</button>&nbsp;&nbsp;
                      </center>
                    </template>
            
                  </vuetable>
                </div>
                
                <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent': ''">
                  <div class="pagination ui basic segment grid">
                    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
                    </vuetable-pagination>
                  </div>
                </div>

            </div>
          </div>
        </div>
    </div>
</template>

<script>
import ValidateField from '../../components/validateFormUtils.js'
import HTTPRequest from '../../controllers/httpRequest.js'
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import secureStorage from '../../controllers/secureStorage';
import { mapState } from 'vuex'

export default {
    components: {
        Vuetable,
        VuetablePagination
    },
    computed: {
        ...mapState(['endPoint', 'profileId', 'serverType']),
    },
    data () {
        return {
            activeKey: "1",
            account: null,
            type: "dark",
            showDrawer: false,
            showDrawerViewDetails: false,
            accountName: null,
            companyName: null,
            firstName: null,
            lastName: null,
            contactNumber: null,
            userName: null,
            emailAddress: null,
            password: null,
            emailAddressConfirmation: null,
            passwordConfirmation: null,
            companyAddress: null,
            companyTinNumber: null,
            businessType: undefined,
            system_business_type_list: [],
            accountTypes:[],
            accountType: undefined,
            selectedAccountType: '',
            billingTypes:[],
            // bryan
            accountTemplate:undefined,
            account_templates_list:[],
            // accountName: "mikee",
            // companyName: "Mikee Inc",
            // firstName: "Mikee",
            // lastName: "Tanqueco",
            // contactNumber: "09175774714",
            // emailAddress: "mikee@imonggo.com",
            // password: "password",
            // emailAddressConfirmation: "mikee@imonggo.com",
            // passwordConfirmation: "password",
            // companyAddress: "Malolos Bulacan",
            // companyTinNumber: "111111",
            fields: [{name: "account_name", title: "Account Name"}, 
                  {name: "company_name", title: "Company Name"}, 
                  {name : "created_at", title: "Create Date"},
                  '__slot:actions'],
            httpOptions: {
              headers: {
                Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web"
              }
            },
            apiURL: "",
            css: {
              table: {
                tableClass: 'table table-sm table-striped table-bordered table-hovered',
                loadingClass: 'loading'
              },
              pagination: {
                infoClass: 'pull-right',
                wrapperClass: 'vuetable-pagination pull-right',
                activeClass: 'btn-primary btn-sm',
                disabledClass: 'disabled',
                pageClass: 'btn btn-border',
                linkClass: 'btn btn-border',
                icons: {
                  first: '',
                  prev: '',
                  next: '',
                  last: '',
                },
              }
            },
            errors: []
        }
    },
    mounted: function () {
        this.apiURL = this.endPoint + "/accounts"
        this.getSystemBusinessType();
        this.getAccountTemplates();
        this.getAccountTypes();
        this.getBillingTypes()
    },
    methods: { 
        addAccount(){
            this.showDrawer = true
        },
        onClose(){
            this.showDrawer = false
            this.showDrawerViewDetails = false
        },
        async onLoadError(error) {
            console.log(error)
        },
        async onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        async getSystemBusinessType(){
         this.system_business_type_list = await HTTPRequest.getRequest(this.endPoint + '/system_business_types', null, null)  
        //  console.log(this.system_business_type_list)
        },
        getSelectedBusinessType(value){
            this.businessType = value;
        },
        async showAccountDetails(id){
            var accountRequest = await HTTPRequest.getRequest(this.endPoint + '/accounts/' + id + '/details', null, null)  
            console.log(accountRequest)  
            this.selectedAccountType  = accountRequest.account_type_id !== null? accountRequest.account_type_id : ''
              let sites = accountRequest.sites.map((site) => {
              if(site.billing_type_id === null) site.billing_type_id = ''
              return site})
            accountRequest = {...accountRequest, sites}
            this.account = accountRequest
            this.showDrawerViewDetails = true
            this.companyName = accountRequest.company_name
            this.accountName = accountRequest.account_name
        },
        async updateAccountStatus(id, status){
            var accountPayload = {
                account: {
                    status: status
                }
            }
            var accountRequest = await HTTPRequest.putRequest(this.endPoint + '/accounts/' + id, null, accountPayload)  
            
            if(accountRequest.error != undefined){
                this.$notification['error']({
                  message: 'Error in suspending account',
                  description: accountRequest.error
                });

            }else{
                if( status == 'S'){
                    this.$notification['success']({
                      message: 'Successfully suspended account',
                      description: "This account will be temporarily unaccessible to users. "
                    });
                } else {
                    this.$notification['success']({
                      message: 'Successfully activated account',
                      description: "This account will now be accessible for use."
                    });
                }
                
            }

            this.showDrawerViewDetails = false
            
        },
        async createAccount(){
            // Do validations

            var valid = true;
            this.errors = [];
            this.errors.push(ValidateField.required('Company Name', this.companyName));
            this.errors.push(ValidateField.required('Account Type', this.accountType));
            this.errors.push(ValidateField.required('Business Type', this.businessType));
            // this.errors.push(ValidateField.charMinAndMax('Company Name', this.companyName, 0, 100));
            this.errors.push(ValidateField.required('Account Name', this.accountName));
            this.errors.push(ValidateField.required('TIN Number', this.companyTinNumber));
            this.errors.push(ValidateField.required('Company Address', this.companyAddress));
            this.errors.push(ValidateField.required('First Name', this.firstName));
            this.errors.push(ValidateField.required('Last Name', this.lastName));
            this.errors.push(ValidateField.required('Contact Number', this.contactNumber));
            this.errors.push(ValidateField.required('Email Address', this.emailAddress));
            this.errors.push(ValidateField.required('Email Address Confirmation', this.emailAddressConfirmation));
            this.errors.push(ValidateField.required('Password', this.password));
            this.errors.push(ValidateField.required('Password Confirmation', this.passwordConfirmation));
            // console.log(this.errors)
            
            this.errors = this._.compact(this.errors);
            if(this.errors.length > 0 ){
                // this.errors = this._.compact(this.errors);
                var errorText = "";
                for(var a= 0; a < this.errors.length; a++){
                    errorText += " " + this.errors[a] + "."
                }
                this.$notification['error']({
                  message: 'Missing required fields',
                  description: errorText
                });
                valid = false
            }

            if(this.companyName.length > 100){
                this.$notification['error']({
                  message: 'Reached maximum character',
                  description: 'Company name field should not exceed 100 characters'
                });
                valid = false
            }

            if(this.emailAddress != this.emailAddressConfirmation){
                this.$notification['error']({
                  message: 'Email addresses do not match',
                  description: "Make sure you entered the correct email addresses"
                });
                valid = false
            }

            if(this.password != this.passwordConfirmation){
                this.$notification['error']({
                  message: 'Passwords do not match',
                  description: "Make sure you entered the same password"
                });
                valid = false
            }

            if(valid){
                // alert("Create account")
                // Create owner of a

                var accountPayload = { account: {
                                            company_name: this.companyName, account_name: this.accountName,
                                            business_type_id: this.businessType, telephone_no: this.contactNumber, status: "A",
                                            account_type_id: this.accountType,
                                        },
                                        company: {
                                            code: _.camelCase(this.companyName), name: this.companyName,
                                            status: "A", address: this.companyAddress, tin: this.companyTinNumber
                                        },
                                        site: {
                                            code:  _.camelCase(this.companyName) + "DEF", 
                                            name: "Default Site", status: "A",
                                            site_type_id: 1, tin: this.companyTinNumber 
                                        },
                                        user: {
                                            first_name: this.firstName, last_name: this.lastName, 
                                            email: this.emailAddress, password: this.password,
                                            name: this.firstName + " " + this.lastName,
                                            user_name: this.userName
                                            // user_name: _.lowerCase(this.firstName) + "_" + _.lowerCase(this.lastName)
                                        }
                                    }    
        
                var accountRequest = await HTTPRequest.postRequest(this.endPoint + '/accounts', null, accountPayload)    
                if(accountRequest.error != undefined){
                    this.$notification['error']({
                        message: 'Failed to create account.',
                        description: accountRequest.error
                    });
                } else {
                    this.$notification['success']({
                        message: 'Successfully created account.',
                        description: "View account details for owner's login credentials"
                    });
                    this.showDrawer = false
                }

            }
        },
        async getAccountTypes(){
            this.accountTypes = await HTTPRequest.getRequest(`${this.endPoint}/account_types`, null, null) 
        },
        getSelectedAccountType(value){
            this.accountType = value;
        },
        // async setUpdate(account_id){
        //     let params = { 'account_type_id': this.selectedAccountType }
        //     let accountRequest = await HTTPRequest.putRequest(`${this.endPoint}/accounts/${account_id}`, null, params) 

        //     if(accountRequest.error != undefined){
        //         this.$notification['error']({
        //             message: 'Error in updating account details',
        //             description: accountRequest.error
        //         });
        //     }else{
        //         this.$notification['success']({
        //             message: 'Successfully updated',
        //             description: "This account details has been updated."
        //         });
        //     }
        //     this.showDrawerViewDetails = false
        // },
        async getBillingTypes(){
          this.billingTypes = await HTTPRequest.getRequest(`${this.endPoint}/billing_types`, null, null) 
        },
        async setAccountType(account_id){
          let params = { 'account_type_id': this.selectedAccountType  }
          await HTTPRequest.putRequest(`${this.endPoint}/accounts/${account_id}`, null, params) 
        },
        async setBillingType(account_id, billing_type_id, site_id){
          let site = await HTTPRequest.getRequest(`${this.endPoint}sites/${site_id}`, null)
          site = {...site, billing_type_id, is_admin:true, company_name: this.companyName}
          await HTTPRequest.putRequest(`${this.endPoint}sites/${site_id}`, null, site )
        },
    }
}

</script>

<style>

.ant-collapse > .ant-collapse-item-active > .ant-collapse-header {
  background-color: #32325d;
  color: white;
}
.account-type-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.account-label-container{
  font-weight: bold;
  margin-right: 5px;
}



</style>


